import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { SmartsheetIcon, SmartsheetSearchResultIcon } from './icon';

export const smartsheetConfig: ThirdPartyConfig = {
	displayName: 'Smartsheet',
	id: 'smartsheet',
	resourceType: ProductResourceTypes3P.Smartsheet,
	icon: get3PLogo(SmartsheetIcon, 'Smartsheet', 'medium'),
	searchResultIcon: get3PLogo(SmartsheetSearchResultIcon, 'Smartsheet', 'large'),
	integrationAri: 'ari:cloud:platform::integration/smartsheet',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
